import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SetAlert } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-sample-alert',
  templateUrl: './sample-alert.component.html',
  styleUrls: ['./sample-alert.component.scss']
})
export class SampleAlertComponent implements OnInit {

  @Input() block: SetAlert[] = [];
  @Input() column: string = '';
  @Input() padding: boolean = false;
  public domainWebsite = environment.urlApi;
  public classColumn = '';
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(
    public helpersService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.changeAlert();
    this.setColumnItem();
  }

  private changeAlert() {
    if (this.block && this.block.length) {
      for (let alert of this.block) {
        switch (alert.tipologia_alert) {
          case "Urgente":
            alert.class = 'alert-danger'
            alert.icon = "exclamation-danger"
            break;
          case "Successo":
            alert.class = 'alert-success'
            alert.icon = "check"
            break;
          case "Attenzione":
            alert.class = 'alert-warning'
            alert.icon = "exclamation-warning"
            break;
          default:
            alert.class = 'alert-neutral'
            alert.icon = "info"
            break;
        }
      }
    }
  }

  private setColumnItem() {
    switch (this.column) {
      case '2':
        if (this.block.length === 1) {
          this.classColumn = 'col-12';
        } else {
          this.classColumn = 'col-12 col-sm-6';
        }
        break;
      case '3':
        if (this.block.length === 1) {
          this.classColumn = 'col-12';
        }
        if (this.block.length === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (this.block.length > 2) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        break;
      case '4':
        if (this.block.length === 1) {
          this.classColumn = 'col-12 col-md-9';
        }
        if (this.block.length === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (this.block.length === 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        if (this.block.length > 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4 col-lg-3';
        }
        break;
      default:
        this.classColumn = 'col-12';
        break;
    }
    if (this.padding) {
      this.classColumn = this.classColumn + ' p-3'
    }
  }
}
